export default __webpack_public_path__ + "static/media/revert.cb657a1e.svg";